var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-stats"},[_c('md-card-header',{attrs:{"data-background-color":_vm.dataBackgroundColor}},[_vm._t("header")],2),_c('md-card-content',[_vm._t("content")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3b4702","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatsCard.vue
// module id = null
// module chunks = 